import React from 'react';
import { Wrapper } from './OrganizationBillingsInvoicingRules.styles';
import { useBaseScreenHook } from '../../../../logic/core/base-screen.hook';

const OrganizationBillingsInvoicingRules: React.FC = () => {
    const { t } = useBaseScreenHook();

    return (
        <Wrapper>
            <h1 className="main-title">{t('invoicingRules.title')}</h1>

            <section className="rule-section">
                <h2>{t('invoicingRules.issuing.title')}</h2>
                <p>{t('invoicingRules.issuing.p1')}</p>
                <p>{t('invoicingRules.issuing.p2')}</p>
            </section>

            <section className="rule-section">
                <h2>{t('invoicingRules.data.title')}</h2>
                <p>{t('invoicingRules.data.p1')}</p>
                <p>{t('invoicingRules.data.p2')}</p>
                <ul>
                    <li>{t('invoicingRules.data.item1')}</li>
                    <li>{t('invoicingRules.data.item2')}</li>
                    <li>{t('invoicingRules.data.item3')}</li>
                    <li>{t('invoicingRules.data.item4')}</li>
                    <li>{t('invoicingRules.data.item5')}</li>
                </ul>
                <p>{t('invoicingRules.data.p3')}</p>
            </section>

            <section className="rule-section">
                <h2>{t('invoicingRules.delivery.title')}</h2>
                <p>{t('invoicingRules.delivery.p1')}</p>
                <p>{t('invoicingRules.delivery.p2')}</p>
                <p>{t('invoicingRules.delivery.p3')}</p>
            </section>

            <section className="rule-section">
                <h2>{t('invoicingRules.corrections.title')}</h2>
                <p>{t('invoicingRules.corrections.p1')}</p>
                <p>{t('invoicingRules.corrections.p2')}</p>
                <p>{t('invoicingRules.corrections.p3')}</p>
            </section>

            <section className="rule-section">
                <h2>{t('invoicingRules.taxes.title')}</h2>
                <p>{t('invoicingRules.taxes.p1')}</p>
                <p>{t('invoicingRules.taxes.p2')}</p>
            </section>

            <section className="rule-section">
                <h2>{t('invoicingRules.contact.title')}</h2>
                <p>
                    {t('invoicingRules.contact.p1')}{' '}
                    <a href={`mailto:${t('invoicingRules.contact.email')}`}>
                        <strong>{t('invoicingRules.contact.email')}</strong>
                    </a>
                </p>
            </section>
        </Wrapper>
    );
};

export default OrganizationBillingsInvoicingRules;
